import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { stripePaymentVerifyV4, deletePaymentIntent } from "../../store/reducers/paymentReducer";
import { useNavigate } from "react-router";
import { CircularProgress } from "@mui/material";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import { addCurrentAccount } from "../../store/reducers/userProfileReducer";

const PaymentStatus = (props) => {

    const [loading, setLoading] = useState('');

    const [ShowPopup, setShowPopup] = useState(false);
    const [CombinedPUHead, setCombinedPUHead] = useState("");
    const [CombinedPUBody, setCombinedPUBody] = useState("");
    const [PopUpType, setPopUpType] = useState("");

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(()=>{
        const {success, failed, cancelled} = props;
        if(success || failed || cancelled){
            setLoading(true);

            if(success){
              setShowPopup(true);
              setCombinedPUHead("Woo hoo !");
              setCombinedPUBody("Payment successful. Please don't reload the page while we create your new trading account");
              setPopUpType("success");
            }
            if(failed){
              setShowPopup(true);
              setCombinedPUHead("Oh snap!");
              setCombinedPUBody("Payment failed");
              setPopUpType("error");
            } 
            if(cancelled){
              setShowPopup(true);
              setCombinedPUHead("Oh snap!");
              setCombinedPUBody("Payment cancelled");
              setPopUpType("error");
            }
            dispatch(stripePaymentVerifyV4()).then(res=>{
                console.log(res)
                setLoading(false);
                setShowPopup(true);
                if(res.account_login_id){
                  dispatch(addCurrentAccount(res.account_login_id));
                  navigate('/AccountMetric')
                  return
                }
                navigate('/PaymentHistory')
              }).catch(err=>{
                console.log(err)
                setLoading(false)
                navigate('/PaymentHistory')
              })

        }
    },[props, dispatch])

    return (
        <div className="challenge-payment-success">
      <CombinedPopup
        type={PopUpType}
        trigger={ShowPopup}
        setTrigger={setShowPopup}
        head={CombinedPUHead}
        subhead={CombinedPUBody}
      />
      {loading?
      <>
      <CircularProgress
        color="primary"
        determinate={false}
        sx={{position: 'absolute', left: '50%', top: '35%'}}
      />
      <h2 style={{color:'white'}}>Processing payment....</h2>
      </>
      :false
      }
    </div>
    )
  
};

export default PaymentStatus;
